
/**
 * Module dependencies.
 */

import { color } from 'react-components/styles';
import { css } from 'styled-components';

/**
 * Export `buttonFontSizes`.
 */

export const buttonFontSizes = {
  large: css`
    font-size: 18px;
    font-weight: 400;
    letter-spacing: -0.2px;
    line-height: 24px;
  `,
  medium: css`
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -0.2px;
    line-height: 18px;
  `,
  small: css`
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -0.2px;
    line-height: 18px;
  `
};

/**
 * Export `colorThemes`.
 */

export const colorThemes = {
  danger: {
    backgroundColor: color('danger100'),
    color: color('danger500'),
    disabled: {
      backgroundColor: color('danger100'),
      color: color('danger200')
    },
    interaction: {
      backgroundColor: color('danger200')
    }
  },
  gray: {
    backgroundColor: color('gray300'),
    color: color('gray900'),
    disabled: {
      backgroundColor: color('gray200'),
      color: color.transparentize('gray900', 0.3)
    },
    interaction: {
      backgroundColor: color('gray400')
    }
  },
  primary: {
    backgroundColor: color('blue500'),
    color: color('white'),
    disabled: {
      backgroundColor: color('blue100'),
      color: color('blue400')
    },
    interaction: {
      backgroundColor: color('blue600')
    }
  },
  secondary: {
    backgroundColor: color('blue200'),
    color: color('blue500'),
    disabled: {
      backgroundColor: color('blue100'),
      color: color('blue300')
    },
    interaction: {
      backgroundColor: color('blue400')
    }
  },
  success: {
    backgroundColor: color('success600'),
    color: color('white'),
    disabled: {
      backgroundColor: color('success100'),
      color: color('white')
    },
    interaction: {
      backgroundColor: color('success700')
    }
  }
};
